import { type Asset } from 'types/asset.types';
import { includePNG } from 'views/VehicleStatus/utils';
import { stringContains } from './string.manipulation';
import { getMakeModel } from 'views/FleetOverview/helpers/map.helpers';

export const mapVehiclesAssets = (vehicleType: string): string => {
  if (
    stringContains('truck', vehicleType) &&
    stringContains('light', vehicleType)
  ) {
    return 'lightTruckImage';
  }

  if (stringContains('loader', vehicleType)) {
    return 'loaderImage';
  }

  if (stringContains('pump', vehicleType)) {
    return 'pumpImage';
  }

  if (
    stringContains('drill', vehicleType) &&
    stringContains('vertical', vehicleType)
  ) {
    return 'verticalDrillImage';
  }

  if (
    stringContains('drill', vehicleType) &&
    stringContains('jumbo', vehicleType)
  ) {
    return 'jumboDrillImage';
  }

  if (stringContains('bolt', vehicleType)) {
    return 'bolterImage';
  }

  if (stringContains('dozer', vehicleType)) {
    return 'dozerImage';
  }
  if (stringContains('grader', vehicleType)) {
    return 'dozerImage';
  }

  if (stringContains('excavator', vehicleType)) {
    return 'excavatorImage';
  }

  if (
    stringContains('truck', vehicleType) &&
    stringContains('haul', vehicleType)
  ) {
    return 'haulTruckImage';
  }

  if (
    stringContains('truck', vehicleType) &&
    stringContains('heavy', vehicleType)
  ) {
    return 'heavyTruckImage';
  }

  if (stringContains('drill', vehicleType)) {
    return 'verticalDrillImage';
  }

  if (stringContains('truck', vehicleType)) {
    return 'lightTruckImage';
  }

  return 'haulTruckImage';
};

export const getImageName = (
  asset: Asset,
  imageSize: 'Large' | 'Small'
): string => {
  const makeModel = getMakeModel(asset);
  const assetTypeKey = asset.assetType?.toLowerCase();
  const imageKey = `${makeModel}_${assetTypeKey}`;

  const imageName = includePNG.includes(imageKey)
    ? `${makeModel}${asset.assetType}Image${imageSize}`
    : assetTypeKey?.includes('light_truck') ||
      assetTypeKey?.includes('haul_truck')
    ? `fallbackhaul_truckImage${imageSize}`
    : `fallbackloaderImage${imageSize}`;

  return imageName;
};

export const getImageNameByMakeModelAndAsset = (
  make: string,
  model: string,
  assetType: string | undefined | null,
  imageSize: 'Large' | 'Small'
): string => {
  if (!make || !model || !assetType) {
    return `fallbackloaderImage${imageSize}`;
  }

  const makeModel = `${make.toLowerCase()}${model.toLowerCase()}`;
  const assetTypeKey = assetType.toLowerCase();
  const imageKey = `${makeModel}_${assetTypeKey}`;

  const imageName = includePNG.includes(imageKey)
    ? `${makeModel}${assetTypeKey}Image${imageSize}`
    : assetTypeKey.includes('light_truck') ||
      assetTypeKey.includes('haul_truck')
    ? `fallbackhaul_truckImage${imageSize}`
    : `fallbackloaderImage${imageSize}`;

  return imageName;
};
